import {
  Button,
  DatePicker,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  datePickerValueToString,
  stringToDatePickerValue,
} from '@civilgrid/ui/components';

const DATE_PLACEHOLDER = 'Select Date';

export type EditDatesDialogProps = {
  open: boolean;
  onClose: () => void;
  startDate: string;
  onStartDateChange: (value: string) => void;
  endDate: string;
  onEndDateChange: (value: string) => void;
  constructionStartDate: string;
  onConstructionStartDateChange: (value: string) => void;
  constructionEndDate: string;
  onConstructionEndDateChange: (value: string) => void;
  onSubmit: () => void;
  isPending: boolean;
};

export function EditDatesDialog({
  open,
  onClose,
  startDate,
  onStartDateChange,
  endDate,
  onEndDateChange,
  constructionStartDate,
  onConstructionStartDateChange,
  constructionEndDate,
  onConstructionEndDateChange,
  onSubmit,
  isPending,
}: EditDatesDialogProps) {
  const hasAnyDate = startDate || endDate || constructionStartDate || constructionEndDate;

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent title="Edit Dates" preventDismiss={!!hasAnyDate} data-testid="home-edit-dates-dialog">
        <DialogBody>
          <div className="grid grid-cols-2 gap-4">
            <DatePicker
              label="Project Start Date"
              placeholder={DATE_PLACEHOLDER}
              value={stringToDatePickerValue(startDate)}
              onChange={(v) => onStartDateChange(datePickerValueToString(v))}
              className="w-full"
              data-testid="home-edit-dates-dialog-start-date"
            />
            <DatePicker
              label="Project End Date"
              placeholder={DATE_PLACEHOLDER}
              value={stringToDatePickerValue(endDate)}
              onChange={(v) => onEndDateChange(datePickerValueToString(v))}
              className="w-full"
              data-testid="home-edit-dates-dialog-end-date"
            />
            <DatePicker
              label="Construction Start Date"
              placeholder={DATE_PLACEHOLDER}
              value={stringToDatePickerValue(constructionStartDate)}
              onChange={(v) => onConstructionStartDateChange(datePickerValueToString(v))}
              className="w-full"
              data-testid="home-edit-dates-dialog-construction-start-date"
            />
            <DatePicker
              label="Construction End Date"
              placeholder={DATE_PLACEHOLDER}
              value={stringToDatePickerValue(constructionEndDate)}
              onChange={(v) => onConstructionEndDateChange(datePickerValueToString(v))}
              className="w-full"
              data-testid="home-edit-dates-dialog-construction-end-date"
            />
          </div>
        </DialogBody>
        <DialogFooter>
          <Button variant="secondary" onClick={onClose} data-testid="home-edit-dates-dialog-cancel">
            Cancel
          </Button>
          <Button onClick={onSubmit} disabled={isPending || !hasAnyDate} data-testid="home-edit-dates-dialog-apply">
            {isPending ? 'Updating…' : 'Apply'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
